module.exports = __webpack_public_path__ + "assets/images/8825628830b655efb805213ff08b241e.png";